module.exports = __webpack_public_path__ + "img/SG.458beece.jpg";